export const dataHooks = {
  numberInputTicker: 'number-input-ticker',
} as const;
